import React from 'react'
import './alert.css'
export default function AlertWidget() {
    return (
        <div id='alert-messages'>
            
        </div>
    )
}
